import { memo, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

const CallbackSignOut: React.FC = memo(() => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // clean up platform flag on signout
    localStorage.removeItem('napster_platform');
    
    if (!auth.isAuthenticated) {
      navigate('/');
    }
  }, [auth.isAuthenticated, navigate]);
  return null;
});

export { CallbackSignOut };
